import {FC, useState} from 'react'

import {AuthModal} from '@/components/user/auth/AuthModal'
import {useAuthContent} from '@/content/user/authentication'
import {useTranslation} from '@/i18n'
import {AuthActionType} from '@/utils/user/constants'

import {Alert, AlertVariant} from '../../alerts/Alert'

export const FormSignIn: FC<React.PropsWithChildren<unknown>> = () => {
  const {t} = useTranslation()
  const {
    formAuth: {haveAccountTitle},
    signIn: {formButtonText},
  } = useAuthContent()
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false)

  return (
    <>
      <Alert
        variant={AlertVariant.info}
        description={t(haveAccountTitle)}
        button={{
          text: t(formButtonText),
          onClick: () => setIsAuthModalOpen(true),
          dataTest: 'loginNoticeButton',
        }}
      />
      <AuthModal
        isVisible={isAuthModalOpen}
        closeModal={() => setIsAuthModalOpen(false)}
        authActionType={AuthActionType.signIn}
      />
    </>
  )
}
